export default "__VITE_ASSET__CQzgo1Rt__"